// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.account-delete-popup {
    background-color: rgba(0, 0, 0, 0.5);
    height: 100%;
    width: 100%;
    z-index: 10;
    top: 0;
    left: 0;
    position: fixed;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0;
    padding: 0;
}

.delete-popup-card {
    background-color: #FFFFFF;
    border-radius: 10px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    width: 360px;
    height: 291px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.delete-popup-card-header {
    width: 360px;
    height: 49px;
    background-color: rgba(0, 75, 160, 1);
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    border-top-right-radius: 10px;
    border-top-left-radius: 10px;
}

.delete-confirm-text {
    font-weight: 400;
    font-size: 16px;
    line-height: 21.82px;
    letter-spacing: 0;
    text-align: center;
    margin: 11px;
    color: rgba(77, 77, 77, 1);
}

.confirm-message {
    font-weight: 700;
    font-size: 16px;
    line-height: 21.82px;
    letter-spacing: 0;
    text-align: center;
    color: rgba(77, 77, 77, 1);
}

.delete-popup-input {
    width: 307px;
    height: 44px;
    position: relative;
    left: 6px;
}

.input-style {
    display: block;
    margin-bottom: 8px;
    font-size: 14px;
    position: relative;
    left: 67px;
    gap: 10px;
}

.delete-input {
    width: 307px;
    height: 40px;
    border-radius: 4px;
    border: 1px solid rgb(189, 189, 189);
    font-size: 12px;
    box-sizing: border-box;
    padding: 13px;
}

.username-style {
    font-size: 13px;
    line-height: 21.82px;
    letter-spacing: 0;
    text-align: center;
    position: relative;
    left: -33px;
}

.cancel-delete-button {
    padding: 10px 0;
    width: 180px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    border-right: 1px solid rgb(189, 189, 189);
    border-top: 1px solid rgb(189, 189, 189);
}

.cancel-text {
    font-family: "Nunito", sans-serif;
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    text-align: center;
    color: rgba(0, 75, 160, 1);
}

.delete-text {
    font-family: "Nunito", sans-serif;
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    text-align: center;
    color: rgb(223, 6, 37);
}

.invalid-message {
    color: rgb(223, 6, 37);
    font-size: 12px;
    margin-top: 8px;
}`, "",{"version":3,"sources":["webpack://./src/app/dashboard/css/accdelete.css"],"names":[],"mappings":"AAAA;IACI,oCAAoC;IACpC,YAAY;IACZ,WAAW;IACX,WAAW;IACX,MAAM;IACN,OAAO;IACP,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,UAAU;AACd;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,yCAAyC;IACzC,YAAY;IACZ,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,qCAAqC;IACrC,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,6BAA6B;IAC7B,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,iBAAiB;IACjB,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,oCAAoC;IACpC,eAAe;IACf,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,oBAAoB;IACpB,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,0CAA0C;IAC1C,wCAAwC;AAC5C;;AAEA;IACI,iCAAiC;IACjC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,iCAAiC;IACjC,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,eAAe;AACnB","sourcesContent":[".account-delete-popup {\n    background-color: rgba(0, 0, 0, 0.5);\n    height: 100%;\n    width: 100%;\n    z-index: 10;\n    top: 0;\n    left: 0;\n    position: fixed;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin: 0;\n    padding: 0;\n}\n\n.delete-popup-card {\n    background-color: #FFFFFF;\n    border-radius: 10px;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n    width: 360px;\n    height: 291px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n.delete-popup-card-header {\n    width: 360px;\n    height: 49px;\n    background-color: rgba(0, 75, 160, 1);\n    color: white;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-top-right-radius: 10px;\n    border-top-left-radius: 10px;\n}\n\n.delete-confirm-text {\n    font-weight: 400;\n    font-size: 16px;\n    line-height: 21.82px;\n    letter-spacing: 0;\n    text-align: center;\n    margin: 11px;\n    color: rgba(77, 77, 77, 1);\n}\n\n.confirm-message {\n    font-weight: 700;\n    font-size: 16px;\n    line-height: 21.82px;\n    letter-spacing: 0;\n    text-align: center;\n    color: rgba(77, 77, 77, 1);\n}\n\n.delete-popup-input {\n    width: 307px;\n    height: 44px;\n    position: relative;\n    left: 6px;\n}\n\n.input-style {\n    display: block;\n    margin-bottom: 8px;\n    font-size: 14px;\n    position: relative;\n    left: 67px;\n    gap: 10px;\n}\n\n.delete-input {\n    width: 307px;\n    height: 40px;\n    border-radius: 4px;\n    border: 1px solid rgb(189, 189, 189);\n    font-size: 12px;\n    box-sizing: border-box;\n    padding: 13px;\n}\n\n.username-style {\n    font-size: 13px;\n    line-height: 21.82px;\n    letter-spacing: 0;\n    text-align: center;\n    position: relative;\n    left: -33px;\n}\n\n.cancel-delete-button {\n    padding: 10px 0;\n    width: 180px;\n    height: 30px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    cursor: pointer;\n    border-right: 1px solid rgb(189, 189, 189);\n    border-top: 1px solid rgb(189, 189, 189);\n}\n\n.cancel-text {\n    font-family: \"Nunito\", sans-serif;\n    font-weight: 600;\n    font-size: 14px;\n    line-height: 18px;\n    text-align: center;\n    color: rgba(0, 75, 160, 1);\n}\n\n.delete-text {\n    font-family: \"Nunito\", sans-serif;\n    font-weight: 600;\n    font-size: 14px;\n    line-height: 18px;\n    text-align: center;\n    color: rgb(223, 6, 37);\n}\n\n.invalid-message {\n    color: rgb(223, 6, 37);\n    font-size: 12px;\n    margin-top: 8px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
